import { useContext } from "react";
import { ConfigContext } from "@/contexts/ConfigProvider";
import type { Component } from "@/types/FormConfig";

export function useFormComponentConfig<N extends Component["name"]>(
  componentName: N,
): Extract<Component, { name: N }> | null {
  const context = useContext(ConfigContext);

  if (!context) {
    throw new Error(
      "useFormComponentConfig must be used within a ConfigProvider",
    );
  }

  const component = context.components.find(
    (component): component is Extract<Component, { name: N }> =>
      component.name === componentName,
  );

  return component ?? null;
}
